import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { Fragment, memo } from "react";
/**
 * This should be in sync with the class name on `BoardStatsBar` below.
 */ export const BOARD_STATS_BAR_HEIGHT = 56;
export const BoardStatsBar = /*#__PURE__*/ memo((param)=>{
    let { actions, className, stats } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("sticky bottom-0 flex h-14 w-full shrink-0 items-center justify-between border-t border-t-grey-4 bg-grey-1 px-3 md:px-12", className),
        "data-disableselect": true,
        "data-testid": "BOARD_STATS_BAR",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-wrap gap-1 text-14 font-medium text-grey-9",
                children: stats === null || stats === void 0 ? void 0 : stats.map((stat)=>{
                    const isLast = stats.indexOf(stat) === stats.length - 1;
                    const element = /*#__PURE__*/ _jsx("div", {
                        children: stat.label
                    }, stat.id);
                    if (isLast) {
                        return element;
                    }
                    return /*#__PURE__*/ _jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: element
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: "\xb7"
                            })
                        ]
                    }, stat.id);
                })
            }),
            !!actions && /*#__PURE__*/ _jsx("div", {
                className: "flex shrink-0 gap-2",
                children: actions
            })
        ]
    });
});
BoardStatsBar.displayName = "BoardStatsBar";
